import algoliaAnalytics from 'search-insights';

algoliaAnalytics('init', {
  appId: process.env.VUE_APP_ALGOLIA_APPLICATIONID,
  apiKey: process.env.VUE_APP_ALGOLIA_SEARCHKEY,
});

export default {
  namespaced: true,
  state: {
    lastClick: null,
  },
  getters: {
    getLastClick: (state) => {
      // override with the values from cookie values if it exist
      if (window.$cookies.get('LastAlgoliaClick')) {
        state.lastClick = window.$cookies.get('LastAlgoliaClick');
      }
      return state.lastClick;
    },
  },
  mutations: {
    setLastClick(state, data) {
      window.$cookies.set(
        'LastAlgoliaClick',
        data,
        moment()
          .add(2, 'hours')
          .toDate(),
      );
      state.lastClick = data;
    },
  },
  actions: {
    registerClick({ commit, dispatch, getters }, data) {
      return new Promise((resolve, reject) => {
        algoliaAnalytics('clickedObjectIDsAfterSearch', {
          index: data.index,
          eventName: 'Click item',
          queryID: data.queryID,
          objectIDs: data.objectIDs,
          positions: data.positions,
        });
        commit('setLastClick', data);
        resolve();
      });
    },
    registerConversionEvent({ commit, state, dispatch }, conversionEvent) {
      algoliaAnalytics('convertedObjectIDsAfterSearch', {
        index: state.lastClick.index,
        eventName: conversionEvent,
        queryID: state.lastClick.queryID,
        objectIDs: state.lastClick.objectIDs,
      });
    },
    checkForConversionEvent(
      {
        commit, state, dispatch, getters,
      },
      conversionEvent,
    ) {
      if (getters.getLastClick) {
        let sendit = false;
        switch (conversionEvent) {
          case 'add_to_shortlist': // Common.js -> addShortlist()
          case 'visit_enquiry': // Enquire.vue -> mounted()
          case 'visit_shortlist': // Enquire.vue -> mounted()
          case 'visit_brochure_request': // Enquire.vue -> mounted()
          case 'send_enquiry': // Enquire.vue -> sendEnquiry()
          case 'send_shortlist': // Enquire.vue -> sendEnquiry()
          case 'send_brochure_request': // Enquire.vue -> sendEnquiry()
          case 'book_now_clicked': // VillaWidget.vue -> createOB()
          case 'booking_confirmed': // CheckoutStep2.vue -> showCCPaymentResponse()
            sendit = /Villas|Collections/.test(getters.getLastClick.index);
            break;
          case 'livechat':
            sendit = /Villas|Collections|CMSPages/.test(getters.getLastClick.index);
            break;
          case 'phonecall':
            break;
          default:
            break;
        }
        if (sendit) {
          dispatch('algolia/registerConversionEvent', conversionEvent, {
            root: true,
          });
        }
      }
    },
  },
};
